module.exports = __webpack_public_path__ + "img/rightBan.9af8ab76.svg";